import { render, staticRenderFns } from "./trade-specs.vue?vue&type=template&id=484fa036&"
import script from "./trade-specs.vue?vue&type=script&lang=js&"
export * from "./trade-specs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports